// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { safeLocalStorage } from '@/lib/safe-storage';

const SUPABASE_URL = "https://llcojpvgertoimsualob.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxsY29qcHZnZXJ0b2ltc3VhbG9iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQyNzMwODAsImV4cCI6MjA2OTg0OTA4MH0.mPKMSynGdAZknGpnaZFqY9Xa1S8cxg2u1LlpJfiRc5I";

// Use shared safeLocalStorage wrapper to avoid iOS storage crashes
const safeStorage: Storage = safeLocalStorage;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: safeStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    debug: false
  },
  global: {
    headers: {
      'x-application-name': 'ascendry-platform',
    },
  },
});

// Listen for auth errors and clear stale sessions that can't be refreshed
// This prevents infinite "Failed to fetch" retry loops from expired refresh tokens
// Only clear stale auth on explicit sign-out, never on transient token refresh failures
// Aggressive clearing during TOKEN_REFRESHED caused tab-switch disconnections
supabase.auth.onAuthStateChange((event, _session) => {
  if (event === 'SIGNED_OUT') {
    console.log('🔒 User signed out, clearing auth data');
    clearStaleAuthData();
  }
});

// Do NOT call getSession() at module init — it acquires an internal auth lock
// that blocks signInWithPassword if the network is slow / server is unresponsive.
// Instead, just passively check for obviously expired tokens in localStorage.

function clearStaleAuthData() {
  try {
    const keys = Object.keys(safeStorage);
    for (const key of keys) {
      if (key.startsWith('sb-') || key.startsWith('supabase.auth.')) {
        safeStorage.removeItem(key);
      }
    }
  } catch (e) {
    console.warn('Failed to clear stale auth data:', e);
  }
}